import { render, staticRenderFns } from "./OpeningCustomer.vue?vue&type=template&id=2d20016a&scoped=true"
import script from "./OpeningCustomer.vue?vue&type=script&lang=js"
export * from "./OpeningCustomer.vue?vue&type=script&lang=js"
import style0 from "./OpeningCustomer.vue?vue&type=style&index=0&id=2d20016a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d20016a",
  null
  
)

export default component.exports